import React from "react";
import { useEffect,useContext,useState } from "react";
import { Link,useParams, useLocation } from 'react-router-dom';
import { GlobalContext } from '../../GlobalContext';
import { useTranslation } from 'react-i18next';
import { AppRefreshContext } from '../../AppRefresh';

const Footer = ({sectionSession}) => {
    const { refreshApp } = useContext(AppRefreshContext);
    const { t, i18n } = useTranslation();
    const location = useLocation();

    const triggerClick = () =>{
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // for a smooth scroll effect
    });
    }
    let pathPrefix = location.pathname.split('/').length;
     const { default_country_detail } = useContext(GlobalContext);
        const { default_langage_details } = useContext(GlobalContext);
        const { check_login_data } = useContext(GlobalContext);
            const { setLogin } = useContext(GlobalContext);
        
    
    if(pathPrefix > 2){
      pathPrefix = location.pathname.split('/')[0];
      pathPrefix = pathPrefix+'/img';
    }else{
        pathPrefix = 'img';
    }
       const logout_action = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('loginbefore');
      localStorage.removeItem('role');
      setLogin(false);
      refreshApp();
      // window.location.replace(window.location.href);
 
    };
  return (
    <footer className="cfan-footer-section">
        <div className="container">
            <div className="cfan-footer-top">
                 <div className="footer-top-wrapper d-flex  justify-content-between">
                    <div className="footer-logo">
                        <Link to="/"><img src={pathPrefix+"/logo.svg"} alt=""/></Link>
                    </div>
                 {!check_login_data ?
               
                    <div className="footer-top-btns">
                        <ul className="header-menu-items d-flex align-items-center">
                           <li><a  data-bs-toggle="modal" data-bs-target="#trainerModal">{t("Trainers")}</a></li>
                            <div className="cfn-login-btn">
                                <li><Link to="https://cfan.org" className="cfn-global-btn" data-bs-toggle="modal" data-bs-target="#loginModal">{t("Login")}</Link></li>
                            </div>
                        </ul>
                    </div>
                 :     
                    <div className="footer-top-btns">
                        <ul className="header-menu-items d-flex align-items-center">
                            <li><Link to="/trainer">{t("Dashboard")}</Link></li>
                            <div className="cfn-login-btn">
                                <li><span  className="cfn-global-btn" onClick={logout_action}>{t("Log_out")}</span></li>
                            </div>
                        </ul>
                    </div>
                 }
                 </div> 
            </div> 
            <div className="cfan-main-footer">
                <div className="main-footer-wrapper d-flex">
                    <div className="footer-items">
                        <h3>{t("Quick_Links")}</h3>
                        <ul>
                            <li><a href="https://cfan.org">{t("about_us")}</a></li>
                            <li><span to="#" onClick={sectionSession}>{t("Upcoming_Training_Sessions")}</span></li>
                        </ul>

                        <div className="tranlate-menu">
                            <div className="dropdown">
                                <button className="btn btn-secondary" type="button" onClick={triggerClick} >
                                  <span className="lang-flag"><img src={default_country_detail != null ? default_country_detail.flag :''} alt=""/></span>{default_country_detail != null ? default_langage_details.label : ''}
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                
                                </ul>
                              </div>
                        </div>

                        <div className="footer-social-share">
                            <ul className="d-flex">
                                <li><a href="https://www.facebook.com/evangelistkolenda/"><img src={pathPrefix+"/fb.svg"} alt=""/></a></li>
                                <li><a href="https://www.instagram.com/evangelistdanielkolenda/"><img src={pathPrefix+"/in.svg"} alt=""/></a></li>
                                
                            </ul>
                        </div>
                    </div>
                    <div className="footer-items">
                        <div className="footer-menu-wrapper d-flex">
                            <div className="footer-menu-items">
                                <ul>
                                    <li><Link to="https://cfan.org/reinhard-bonnke">{t("Reinhard_Bonnke")}</Link></li>
                                    <li><a href="https://cfan.org">{t("History")}</a></li>
                                    <li><Link to="https://danielkolenda.com">{t("Daniel_Kolenda")}</Link></li>
                                </ul>
                            </div>
                            <div className="footer-menu-items">
                                <ul>
                                    <li><Link to="/privacypolice">{t("Privacy_Policy")}</Link></li>
                                    <li><Link to="/termsandconditions">{t("Terms_Conditions")}</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="footer-items">
                        <h3>{t("Contact_info")}</h3>
                        <div className="footer-contact">
                            <span className="c-heading">{t("Address")}: </span>
                            <div className="contact-info d-flex">
                                <div className="footer-icons"><span><img src={pathPrefix+
                                    "/location.svg"} alt=""/></span></div>
                                <p>6880 Lake Ellenor Dr, Orlando, FL 32809</p>
                            </div>
                        </div>
                        <div className="footer-contact">
                            <span className="c-heading">{t("Phone")}: </span>
                            <div className="contact-info d-flex">
                                <div className="footer-icons"><span><img src={pathPrefix+"/phone.svg"} alt=""/></span></div>
                                <p>  <Link href="tel:1 888 800 - 2767">1 888 800 - 2767  </Link></p>
                            </div>
                        </div>
                        <div className="footer-contact">
                            <span className="c-heading">{t("Email")}: </span>
                            <div className="contact-info d-flex">
                                <div className="footer-icons"><span><img src={pathPrefix+"/email.svg"} alt=""/></span></div>
                                <p>  <Link href="mailto:usa@cfan.org">usa@cfan.org  </Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cfan-copyright">
                <div className="copyright-wrapper">
                    <div className="website-info">
                        <p><span className="copyright-year">2025</span> © One2One | Christ For All Nations. All rights reserved.</p>
                    </div>
                    <div className="dev-info">
                        <p>By Orfeostory –   <Link href="https://www.orfeostory.com/" target="_blank" rel="noopener noreferrer">Web Design  </Link> &   <Link href="https://www.orfeostory.com/" target="_blank" rel="noopener noreferrer">App Developer Singapore  </Link></p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  );
};

export default Footer;